export default "__VITE_ASSET__BHkbJhJq__"